module.exports = __webpack_public_path__ + "../resources/images/illustration_search_folder-8ce00956b36c5f5d40c64b1691faa56f.svg";